import Spinner from 'react-bootstrap/Spinner';

export const Spinnersmall = () => {
  return (
    <Spinner animation="border" size="sm" />
  );
};